// src/services/dashboardService.js

import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../api/baseQuery';

export const dashboardService = createApi({
  reducerPath: 'dashboardService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['DashboardStats', 'UserMetrics'],

  endpoints: (builder) => ({
    /**
     * Genel dashboard istatistiklerini çeker.
     * Admin için platform geneli, diğer roller için tenant geneli istatistikleri döndürür.
     * Backend, rolü token'dan anlayıp doğru veriyi döndürmelidir.
     */
    getDashboardStats: builder.query({
      query: () => ({
        url: '/dashboard/stats', // ÖRNEK ENDPOINT - Backend hazır olduğunda güncellenecek
        method: 'GET',
      }),
      providesTags: ['DashboardStats'],
      // Gerçek veri gelene kadar geçici mock data
      // Backend hazır olunca bu 'transformResponse' veya 'queryFn' kaldırılabilir.
      transformResponse: (response) => {
        // Eğer gerçek bir yanıt gelirse onu kullan
        if (response && response.isSuccess) {
          return response.value;
        }
        // Gelmezse, geçici veri döndür
        return {
          totalTenants: 12,
          totalUsers: 256,
          activeCampaigns: 8,
          totalCampaigns: 22,
          brandsCount: 45,
          engagementRate: 85,
        };
      },
    }),

    /**
     * Kullanıcıya özel metrikleri (örn. son 7 gündeki aktiviteler) çeker.
     * @param {object} params - { period: '7d' | '30d' }
     */
    getUserMetrics: builder.query({
      query: (params) => ({
        url: `/dashboard/user-metrics`, // ÖRNEK ENDPOINT
        params: { period: params.period || '7d' },
        method: 'GET',
      }),
      providesTags: ['UserMetrics'],
      // Geçici mock data
      transformResponse: (response) => {
        if (response && response.isSuccess) {
          return response.value;
        }
        return {
          loginCount: 12,
          actionsCompleted: 45,
          newAchievements: 3,
        };
      },
    }),
  }),
});

// Hook'ları export et
export const {
  useGetDashboardStatsQuery,
  useGetUserMetricsQuery,
} = dashboardService;